import useShipmentsStore from './useShipmentsStore';
import shipmentsPostProcessor from '../helpers/shipmentsPostProcessor';
import { validationErrorParser } from '@/helpers/beErrorMsgParser';
import usePaginatedTableData from '@/hooks/usePaginatedTableData';

const parsingOptions = {
  errorParser: validationErrorParser,
  trackError: false,
};

const useGetShipments = () => {
  const dispatch = useShipmentsStore((state) => state.dispatch);
  const order = useShipmentsStore((state) => state.order);
  const sortBy = useShipmentsStore((state) => state.sortBy);
  const offset = useShipmentsStore((state) => state.offset);
  const pageSize = useShipmentsStore((state) => state.pageSize);
  const contractState = useShipmentsStore((state) => state.contractState);
  const rts = useShipmentsStore((state) => state.rts);
  const incidentFilter = useShipmentsStore((state) => state.incidentFilter);
  const searchTerms = useShipmentsStore((state) => state.searchTerms);
  const isArchived = useShipmentsStore((state) => state.isArchived);
  const isDeleted = useShipmentsStore((state) => state.isDeleted);
  const getAll = useShipmentsStore((state) => state.getAll);

  const incident = (() => {
    if (!incidentFilter) {
      return {};
    }
    switch (incidentFilter[0]) {
      case 'FLAGGED':
        return { withLitigationStatuses: 'FLAGGED' };
      case 'SOLVED':
        return { withLitigationStatuses: 'SOLVED' };
      case 'INSPECTED':
        return { withSecurityInspections: true };
      default:
        return {};
    }
  })();

  usePaginatedTableData({
    params: {
      path: '/shipments',
      method: 'get',
      reducer: shipmentsPostProcessor,
    },
    dispatch,
    queryParams: {
      pageSize,
      offset,
      sortBy,
      order,
      ...(isDeleted ? {} : { getAll }),
      isArchived: isArchived || '',
      isDeleted: isDeleted || '',
      contractState: contractState || '',
      rts: rts || '',
      ...incident,
      ...searchTerms,
    },
    queryParamsOptions: { skipEmptyString: true },
    service: 'shipment',
    errorParsingOptions: parsingOptions,
  });
};

export default useGetShipments;
